import { render, staticRenderFns } from "./agentlist.vue?vue&type=template&id=47c70013&scoped=true&"
import script from "./agentlist.vue?vue&type=script&lang=js&"
export * from "./agentlist.vue?vue&type=script&lang=js&"
import style0 from "./agentlist.vue?vue&type=style&index=0&id=47c70013&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c70013",
  null
  
)

export default component.exports